export default "__VITE_ASSET__BxcvrEfX__"